export default "__VITE_ASSET__bcc1c32b__"